import ServiceIcon from "./ServiceIcon";

// Витрина сервисов для человека, у которого карты ещё нет.
//
// Три ленты плывут навстречу друг другу. Это не движение ради движения: свет
// на экране идёт сверху, от карты, поэтому верхний ряд ярче нижнего — ленты
// живут в той же сцене, что и всё остальное, а не поверх неё.
//
// Двигаем ТОЛЬКО transform, поэтому браузер не пересобирает раскладку и кадр
// обходится бесплатно. Ряд отрисован дважды: сдвиг ровно на половину замыкает
// петлю без шва.
//
// Ряды собраны по смыслу, а не случайно: развлечения, работа, жизнь. Человек
// скользит взглядом по ленте и должен за секунду узнать свой сценарий.
const ROWS = [
  ["netflix", "spotify", "youtube", "apple-music", "twitch", "discord", "figma"],
  ["chatgpt", "claude", "gemini", "notion", "zoom", "amazon", "booking"],
  ["uber", "ubereats", "airbnb", "starbucks", "mcdonalds", "seven-eleven"],
];

const MODIFIERS = ["lp-mrow--a", "lp-mrow--b", "lp-mrow--c"];

const ServiceShowcase = ({ title, hint }) => (
  <div className="space-y-2.5">
    {title ? (
      <p className="text-center text-[10px] font-semibold uppercase tracking-[0.13em] text-muted-foreground">
        {title}
      </p>
    ) : null}

    <div className="lp-marquee -mx-4">
      {ROWS.map((row, index) => (
        <div key={index} className={`lp-mrow ${MODIFIERS[index]} mb-2.5`}>
          {[...row, ...row].map((slug, position) => (
            <span key={`${slug}-${position}`} className="lp-brand">
              <ServiceIcon slug={slug} />
            </span>
          ))}
        </div>
      ))}
    </div>

    {hint ? (
      <p className="px-4 text-center text-xs leading-relaxed text-muted-foreground">{hint}</p>
    ) : null}
  </div>
);

export default ServiceShowcase;
